
import React from 'react';
import GuessTale from 'views/GuessTale';

const KindergartenPage = () => {
  return <GuessTale/>;
};

export default KindergartenPage;
